// extracted by mini-css-extract-plugin
module.exports = {"shoppingCenterGroupWrapper":"_3HIkCaRpJNS-dpnQEQdkBn"};